import { SvgIcon } from "@material-ui/core";
import React from "react";

const MicOff = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 22.375 22.375">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="22.375"
        height="22.375"
        viewBox="0 0 22.375 22.375"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rectangle_6475"
              data-name="Rectangle 6475"
              width="22.375"
              height="22.375"
            />
          </clipPath>
        </defs>
        <g id="mic_off" clipPath="url(#clip-path)">
          <g id="mic_1_" data-name="mic (1)" transform="translate(1.602 2.849)">
            <path
              id="Path_1"
              data-name="Path 1"
              d="M0,0H18.064V18.064H0ZM0,0H18.064V18.064H0Z"
              fill="none"
            />
            <path
              id="Path_2"
              data-name="Path 2"
              d="M18.09,10.792H16.805a3.711,3.711,0,0,1-.329,1.548l.931.929A4.884,4.884,0,0,0,18.09,10.792Zm-3.034.124c0-.041.011-.083.011-.124V6.262a2.267,2.267,0,1,0-4.533,0V6.4ZM6.963,4.752,6,5.714l4.541,4.538V10.8A2.261,2.261,0,0,0,12.8,13.061,2.331,2.331,0,0,0,13.292,13l1.254,1.253a4.167,4.167,0,0,1-1.746.389,3.919,3.919,0,0,1-4-3.85H7.511a5.268,5.268,0,0,0,4.533,5.073v2.472h1.511V15.866a5.358,5.358,0,0,0,1.919-.683l3.162,3.16.963-.959Z"
              transform="translate(-3.768 -2.509)"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default MicOff;
